import React, { useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import { Calendar } from "primereact/calendar";
import Cards from "./Cards";
import { formatToEncodedISOString, getCurrentFinancialYear, getFinancialYears } from "../../Utils/general";
import RevenueRateCard from "./RevenueRateCard";
import { getYear } from "date-fns";
import { ARPC, ARR, MRR } from "../../Constant/constant";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { REVENUE_RATE } from "../../apiClient/apiEndpoints";
import { formatRupees } from "../../Utils/common";

const { SimDropdownBasic } = UiComponents;

let years = getFinancialYears(2023);

let dashboardCard = [
  {
    name: "Total Clients",
    type: "group",
    showRsValue:false
  },
  {
    name: "Total Users",
    type: "user",
    showRsValue:false
  },
  {
    name: "Total Applications",
    type: "application",
    showRsValue:false
  },
  {
    name: "Total Resources",
    type: "resource",
    showRsValue:false
  },
  {
    name: "Total Revenue",
    type: "revenue",
    showRsValue:true
  },
  {
    name: "Total Visits",
    type: "visit",
    showRsValue:false
  },
];

const CardsList = ({ dateRange }) => {
  const [arrRange, setArrRange] = useState(null);
  const [arpcRange, setArpcRange] = useState(null);
  const [arrValue, setArrValue] = useState(0);
  const [arpcValue, setArpcValue] = useState(null);
  const [mrrDate, setMrrDate] = useState(new Date());
  const [mrrValue, setMrrValue] = useState(0);

  useEffect(() => {
    let currentFinancialYear = getCurrentFinancialYear();

    setArrRange({
      endDate: currentFinancialYear.endDate,
      key: currentFinancialYear.key,
      label: currentFinancialYear.label,
      startDate: currentFinancialYear.startDate,
    });

    setArpcRange({
      endDate: currentFinancialYear.endDate,
      key: currentFinancialYear.key,
      label: currentFinancialYear.label,
      startDate: currentFinancialYear.startDate,
    });
  }, []);

  useEffect(() => {
    getAverageRevenueData(ARR, arrRange);
  }, [arrRange]);

  useEffect(() => {
    getAverageRevenueData(ARPC, arpcRange);
  }, [arpcRange]);

  useEffect(() => {
    const startOfMonth = new Date(mrrDate.getFullYear(), mrrDate.getMonth(), 1, 0, 0, 0, 0);
    const endOfMonth = new Date(mrrDate.getFullYear(), mrrDate.getMonth() + 1, 0, 23, 59, 59, 999);
    let range = {
      startDate: formatToEncodedISOString(startOfMonth),
      endDate: formatToEncodedISOString(endOfMonth),
    };
    getAverageRevenueData(MRR, range);
  }, [mrrDate]);

  const getAverageRevenueData = async (type, dateRange) => {
    try {
      let params = {};
      if (type === ARR) {
        params = {
          startDate: dateRange ? dateRange.startDate : null,
          endDate: dateRange ? dateRange.endDate : null,
          key: null,
        };
      } else if (type === ARPC) {
        params = {
          startDate: dateRange ? dateRange.startDate : null,
          endDate: dateRange ? dateRange.endDate : null,
          key: null,
        };
      } else if (type === MRR) {
        params = {
          startDate: dateRange ? dateRange.startDate : null,
          endDate: dateRange ? dateRange.endDate : null,
          key: null,
        };
      }
      let data = await apiClient(`${SSO_URL}${REVENUE_RATE}/${type}`, { params });
      if (type === ARR) {
        setArrValue(data);
      } else if (type === ARPC) {
        setArpcValue(data);
      } else if (type === MRR) {
        setMrrValue(data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onOptionClick = (type, value) => {
    if (type === ARR) {
      setArrRange(value);
    } else if (type === ARPC) {
      setArpcRange(value);
    }
  };

  return (
    <>
      {dashboardCard.map((item, index) => {
        return <Cards dateRange={dateRange} index={index} name={item.name} type={item.type} showRsValue={item.showRsValue} />;
      })}

      <div className="stat-item">
        <div className="statInfo-Parent">
          <p>ARR</p>
          <SimDropdownBasic
            className="linecheckbtn"
            labelIcon={arrRange?.label || `select ARR`}
            data={years}
            onOptionClick={(value) => onOptionClick(ARR, value)}
          />
        </div>
        <h6> {formatRupees(arrValue || 0)} </h6>
      </div>
      <div className="stat-item">
        <div className="statInfo-Parent">
          <p>MRR</p>
          <Calendar value={mrrDate} onChange={(e) => setMrrDate(e.value)} view="month" dateFormat="mm/yy" />
        </div>
        <h6>{formatRupees(mrrValue || 0)}</h6>
      </div>
      <div className="stat-item">
        <div className="statInfo-Parent">
          <p>ARPU</p>
          <SimDropdownBasic
            className="linecheckbtn"
            labelIcon={arpcRange?.label || `select ARPR`}
            data={years}
            onOptionClick={(value) => onOptionClick(ARPC, value)}
          />
        </div>
        <h6>{formatRupees(arpcValue || 0)}</h6>
      </div>
    </>
  );
};

export default CardsList;
